export default __webpack_public_path__ + "static/media/scientist-animated.da1e2655.gif";